import React from 'react'
import styled from 'styled-components'
import { Card } from 'mtv-mswap-uikitty'

export const BodyWrapper = styled(Card)`
  border-radius: 24px;
  max-width: 700px;
  width: 100%;
  z-index: 1;
  background: #04E4D4;

`

/**
 * The styled container element that wraps the content of most pages and the tabs.
 */
export default function AppBody({ children }: { children: React.ReactNode }) {
  return <BodyWrapper className="app-body">{children}</BodyWrapper>
}
